export default __webpack_public_path__ + "static/media/GreenFull.881ffd21.mp4";